import React from 'react';
import { STUDIO_COPY } from '../config';
import type { ReelDurationTier } from '../api/types';

const TIERS: { id: ReelDurationTier; label: string; hint: string }[] = [
  { id: 'short', label: STUDIO_COPY.durationShort, hint: STUDIO_COPY.durationShortHint },
  { id: 'mid', label: STUDIO_COPY.durationMid, hint: STUDIO_COPY.durationMidHint },
  { id: 'long', label: STUDIO_COPY.durationLong, hint: STUDIO_COPY.durationLongHint },
];

type DurationTierPickerProps = {
  value: ReelDurationTier;
  onChange: (tier: ReelDurationTier) => void;
  disabled?: boolean;
  compact?: boolean;
  idPrefix?: string;
};

const DurationTierPicker: React.FC<DurationTierPickerProps> = ({
  value,
  onChange,
  disabled = false,
  compact = false,
  idPrefix = 'studio-duration',
}) => {
  return (
    <div className="studio-duration-picker" data-testid="studio-duration-picker">
      <p className="studio-duration-picker-label">{STUDIO_COPY.durationLabel}</p>
      <div
        className={
          compact ? 'studio-duration-picker-row compact' : 'studio-duration-picker-row'
        }
        role="radiogroup"
        aria-label={STUDIO_COPY.durationLabel}
      >
        {TIERS.map((tier) => {
          const selected = value === tier.id;
          return (
            <button
              key={tier.id}
              type="button"
              role="radio"
              aria-checked={selected}
              id={`${idPrefix}-${tier.id}`}
              data-testid={`${idPrefix}-${tier.id}`}
              className={
                selected
                  ? 'studio-duration-chip is-selected'
                  : 'studio-duration-chip'
              }
              disabled={disabled}
              onClick={() => onChange(tier.id)}
            >
              <span className="studio-duration-chip-label">{tier.label}</span>
              <span className="studio-duration-chip-hint">{tier.hint}</span>
            </button>
          );
        })}
      </div>
      <p className="studio-duration-picker-blurb">{STUDIO_COPY.durationBlurb}</p>
    </div>
  );
};

export default DurationTierPicker;
